import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = { class: "as-history-item__body" }
const _hoisted_7 = { class: "as-competition" }
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { class: "as-center a" }
const _hoisted_10 = { class: "as-center a" }
const _hoisted_11 = { class: "as-competition" }
const _hoisted_12 = { class: "as-competition__table" }
const _hoisted_13 = { class: "as-center a" }
const _hoisted_14 = { class: "as-center a" }

import IconOffsideMis from '~src/components/icons/foot_stats/IconOffsideMis.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref, computed } from 'vue';
    import { getClassForItem } from '~src/helpers/footystats';

    
const __default__ = {};

interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    interface IData{
        title: string;
        home: {
            value: number;
            _class: string;
        };
        away: {
            value: number;
            _class: string;
        };
        avg: {
            value: number;
            _class: string;
        };
        is_percent?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OffsideMiscList',
  props: {
    match: {},
    mode: { default: 'as-win' },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const props = __props

    const activeTab = ref('team')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const offsides = computed(() => {
        const _data: IData[] = [
            {
                title: "TB Việt vị mỗi đội",
                home: {
                    value: getValueWithMode('home', 'offsidesAVG_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'offsidesAVG_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'offsidesAVG_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'offsidesAVG_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'offsidesAVG_overall'), getValueWithMode('away', 'offsidesAVG_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'offsidesAVG_overall'), getValueWithMode('away', 'offsidesAVG_overall')))
                },
                is_percent: false
            },
            {
                title: "Trên 0.5",
                home: {
                    value: getValueWithMode('home', 'over05OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over05OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over05OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over05OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over05OffsidesPercentage_overall'), getValueWithMode('away', 'over05OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over05OffsidesPercentage_overall'), getValueWithMode('away', 'over05OffsidesPercentage_overall')))
                },
                is_percent: true
            },
            {
                title: "Trên 1.5",
                home: {
                    value: getValueWithMode('home', 'over15OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over15OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over15OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over15OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over15OffsidesPercentage_overall'), getValueWithMode('away', 'over15OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over15OffsidesPercentage_overall'), getValueWithMode('away', 'over15OffsidesPercentage_overall')))
                },
                is_percent: true
            },
            {
                title: "Trên 2.5",
                home: {
                    value: getValueWithMode('home', 'over25OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over25OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over25OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over25OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over25OffsidesPercentage_overall'), getValueWithMode('away', 'over25OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over25OffsidesPercentage_overall'), getValueWithMode('away', 'over25OffsidesPercentage_overall')))
                },
                is_percent: true
            },
            {
                title: "Trên 3.5",
                home: {
                    value: getValueWithMode('home', 'over35OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over35OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over35OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over35OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over35OffsidesPercentage_overall'), getValueWithMode('away', 'over35OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over35OffsidesPercentage_overall'), getValueWithMode('away', 'over35OffsidesPercentage_overall')))
                },
                is_percent: true
            }
        ]

        return _data;
    });

    const mics = computed(() => {
        const _data: IData[] = [
            {
                title: "Phạm lỗi/trận đấu",
                home: {
                    value: getValueWithMode('home', 'foulsAVG_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'foulsAVG_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'foulsAVG_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'foulsAVG_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'foulsAVG_overall'), getValueWithMode('away', 'foulsAVG_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'foulsAVG_overall'), getValueWithMode('away', 'foulsAVG_overall')))
                },
            },
            {
                title: "Đối thủ phạm lỗi/trận đấu",
                home: {
                    value: getValueWithMode('home', 'fouls_against_avg_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'fouls_against_avg_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'fouls_against_avg_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'fouls_against_avg_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'fouls_against_avg_overall'), getValueWithMode('away', 'fouls_against_avg_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'fouls_against_avg_overall'), getValueWithMode('away', 'fouls_against_avg_overall')))
                },
            },
            {
                title: "Kiểm soát trung bình",
                home: {
                    value: getValueWithMode('home', 'possessionAVG_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'possessionAVG_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'possessionAVG_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'possessionAVG_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'possessionAVG_overall'), getValueWithMode('away', 'possessionAVG_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'possessionAVG_overall'), getValueWithMode('away', 'possessionAVG_overall')))
                },
            },
            {
                title: "Hòa",
                home: {
                    value: getValueWithMode('home', 'drawPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'drawPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'drawPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'drawPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'drawPercentage_overall'), getValueWithMode('away', 'drawPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'drawPercentage_overall'), getValueWithMode('away', 'drawPercentage_overall')))
                },
            }
        ]

        return _data;
    });

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts', half = 1) => {
        const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;
        if (!__data || !__data.stats || !__data.stats.stats.hasOwnProperty(mode)) {
            return 0;
        }

        return __data.stats[mode] as number;
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconOffsideMis),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, " Việt vị & Misc ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", {
                        'as-active': activeTab.value === 'team'
                    }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('team')))
          }, " Đội việt vị ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", {
                        'as-active': activeTab.value === 'all'
                    }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('all')))
          }, " Việt vị trận đấu ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("th", null, "Đội việt vị", -1)),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.away_name), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(offsides.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.home._class}`)
                    }, _toDisplayString(item.home.value) + "%", 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.away._class}`)
                    }, _toDisplayString(item.away.value) + "%", 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.avg._class}`)
                    }, _toDisplayString(item.avg.value) + "%", 3)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("th", null, "Thống kê đa dạng", -1)),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.footyStats?.away_name), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mics.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.home._class}`)
                    }, _toDisplayString(item.home.value) + _toDisplayString(item.is_percent ? '%' : ''), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.away._class}`)
                    }, _toDisplayString(item.away.value) + _toDisplayString(item.is_percent ? '%' : ''), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.avg._class}`)
                    }, _toDisplayString(item.avg.value) + _toDisplayString(item.is_percent ? '%' : ''), 3)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})